import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSidebarHiddenRightWide: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sidebar-hidden-right-wide"><path d="M2.75 4.75H21.25V19.25H2.75V4.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M17.75 7.5V16.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconSidebarHiddenRightWide;
